import { useNavigate } from '@tanstack/react-router';
import type { AnchorHTMLAttributes } from 'react';

/**
 * Ссылка на адрес, собранный строкой, с переходом через роутер.
 *
 * Типизированный `Link` принимает только известные маршруты с параметрами.
 * Оболочке это неудобно: пункты меню строятся из схемы сайта, а переключатель
 * окружения подменяет кусок текущего адреса. Здесь — обычный `<a href>`:
 * открывается в соседней вкладке по Ctrl/⌘-щелчку, а простой щелчок уходит
 * в роутер без перезагрузки страницы.
 */
export function RouterAnchor({
  href,
  onClick,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  const navigate = useNavigate();

  return (
    <a
      href={href}
      {...rest}
      onClick={(event) => {
        onClick?.(event);

        if (
          event.defaultPrevented ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          event.button !== 0
        ) {
          return;
        }

        event.preventDefault();
        void navigate({ href });
      }}
    />
  );
}
